/*
 * Public API Surface of icons
 */

export { TIcon, ICONS_URLS } from './lib/icon/icon.component';
export { IconsModule } from './lib/icons.module';
